module.exports = __webpack_public_path__ + "img/alberto-salvatori.753cc085.jpg";